<div class="row" *ngIf="!showForm">
    <div class="col-md-6" *ngIf="isPowerUser">
        <button 
            class="ds-btn ds-btn-primary ds-btn-small"
            [ngClass]="{'pull-right': !isArabic , 'pull-left' :isArabic }"
            [innerText]="'UserProfile.AddOwner' | translate"
            (click)="addOwnerClick()">
        </button>
    </div>
    <div class="col-md-6">
      <app-list-filter (search)="updateSearchText($event)"></app-list-filter>
    </div>
</div>


<form [formGroup]="form" *ngIf="showForm">
    <div class="row">
        <div class="col-md-6" >
            <bs-ng-dropdown
              *ngIf="!isRegistered || isNew"
              formControlName="PartnershipType"
              identifier="PartnershipType"
              name="PartnershipType"
              key="UserProfile.PartnershipType"
              [items]="lookups?.PartnershipTypes"
              [bindLabel]="defaultLookupDisplayProperty"
              (change)="onPartnershipTypeChange()">
            </bs-ng-dropdown>
            <app-bs-display 
              *ngIf="isRegistered && !isNew"
              key="UserProfile.PartnershipType"
              [valueText]="form.controls.PartnershipType.value | lookup:lang">
            </app-bs-display>
        </div>

        <div class="col-md-6" *ngIf="form.controls.IdType">
            <div class="form-group" *ngIf="!isRegistered || isNew">
              <label class="form-control-label-required">{{("UserProfile.IdType" | translate).labelText}}</label>
              <div class="row">
                <div class="col-md-6">
                  <bs-ng-radiobox
                    formControlName="IdType"
                    identifier="IdTypeIdNumber"
                    key="UserProfile.IdType.IdNumber"
                    name="IdType"
                    [set]="'EID'"
                    (change)="onIdTypeChange($event)">
                  </bs-ng-radiobox>
                </div>
                <div class="col-md-6">
                  <bs-ng-radiobox
                    formControlName="IdType"
                    identifier="IdTypePassport"
                    key="UserProfile.IdType.Passport"
                    name="IdType"
                    [set]="'Passport'"
                    (change)="onIdTypeChange($event)">
                  </bs-ng-radiobox>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="isRegistered && !isNew">
              <app-bs-display
                key="UserProfile.IdType"
                [valueText]="('UserProfile.IdType.' + form.controls.IdType.value + '.labelText') | translate">
              </app-bs-display>
            </div>
        </div>

        <div class="col-md-6" *ngIf="form.controls.IdNumber">
            <bs-ng-text
                *ngIf="!isRegistered || isNew"
                formControlName="IdNumber"
                identifier="IdNumber"
                name="IdNumber"
                key="UserProfile.IdNumber"
                [prefix]="emiratesIdMaskPrefix"
                [mask]="emiratesIdMask"
                (change)="onIDChange()">
            </bs-ng-text>
            <app-bs-display
                *ngIf="isRegistered && !isNew"
                key="UserProfile.IdNumber"
                [valueText]="form.controls.IdNumber.value">
            </app-bs-display>
        </div>

        <div class="col-md-6" *ngIf="form.controls.OTP">
          <bs-ng-text
              formControlName="OTP"
              identifier="OTP"
              name="OTP"
              key="UserProfile.OTP"
              (change)="onOTPChange()">
          </bs-ng-text>
        </div>

        <div class="col-md-12" *ngIf="otpAlert">
          <app-bs-alert
            class="has-error is-invalid" 
            [importance]="otpAlertType"
            [alert]="otpAlert">
          </app-bs-alert>
        </div>

        <div class="col-md-6" *ngIf="form.controls.Passport">
            <bs-ng-text
                formControlName="Passport"
                identifier="Passport"
                name="Passport"
                key="UserProfile.Passport"
                maxLength="50">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
          <app-bs-display
            *ngIf="!isEditable"
            key="UserProfile.Nationality"
            [valueText]="form.controls.Nationality.value | lookup:lang">
          </app-bs-display>
          <bs-ng-dropdown
            *ngIf="isEditable"
            formControlName="Nationality"
            identifier="Nationality"
            name="Nationality"
            key="UserProfile.Nationality"
            [items]="lookups.Countries"
            [bindLabel]="defaultLookupDisplayProperty">
          </bs-ng-dropdown>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display 
              *ngIf="!isEditable"
              key="UserProfile.NameAr"
              [valueText]="form.controls.NameAr.value">
            </app-bs-display>
            <bs-ng-text
              *ngIf="isEditable"
              formControlName="NameAr"
              identifier="NameAr"
              name="NameAr"
              key="UserProfile.NameAr"
              maxLength="150">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
            <app-bs-display
              *ngIf="!isEditable"
              key="UserProfile.NameEn"
              [valueText]="form.controls.NameEn.value">
            </app-bs-display>
            <bs-ng-text
              *ngIf="isEditable"
              formControlName="NameEn"
              identifier="NameEn"
              name="NameEn"
              key="UserProfile.NameEn"
              maxLength="150">
            </bs-ng-text>
        </div>

        <div class="col-md-6" *ngIf="showControls">
          <bs-ng-text
              formControlName="Mobile"
              identifier="Mobile"
              key="UserProfile.Mobile"
              name="Mobile"
              [minlength]="10"
              [maxlength]="20"
              [mask]="phoneNumberMask">
          </bs-ng-text>
        </div>
        

    </div>
    <div class="row">
        <div class="col-md-6">
            <button *ngIf="isNew"
                    [innerText]="'Add' | translate"
                    type="submit"
                    class="ds-btn ds-btn-primary ds-btn-small"
                    (click)="save()">
            </button>
            <button *ngIf="!isNew"
                    [innerText]="'Save' | translate"
                    type="submit"
                    class="ds-btn ds-btn-primary ds-btn-small"
                    (click)="save()">
            </button>
            <button [innerText]="'Cancel' | translate"
                    class="ds-btn ds-btn-secondary ds-btn-small m-2"
                    (click)="cancel()">
            </button>
        </div>
    </div>
</form>

<div class="row mt-2">
  <div class="col-12">
    <ul *ngIf="activeOwners && activeOwners.length" class="list-group ds-list-group-default">
      
      <li class="list-group-item ds-list-group-head-default d-flex justify-content-start align-items-center px-2">
        <app-detail-display class="w-mm-30" [value]="" key="UserProfile.PartnershipType">
        </app-detail-display>

        <app-detail-display *ngIf="isArabic" class="w-mm-50" [value]="" key="UserProfile.NameAr">
        </app-detail-display>

        <app-detail-display *ngIf="!isArabic" class="w-mm-50" [value]="" key="UserProfile.NameEn">
        </app-detail-display>
      </li>

      <li *ngFor="let owner of activeOwners | searchFilter: searchText 
                  | paginate: { id: 'ownersPagination', itemsPerPage: itemsPerPage, currentPage: currentPage };
                  let index = index"
            class="list-group-item d-flex justify-content-start align-items-center">
        <div class="ds-list-group-item-head d-flex w-100 p-2"
            [class.ds-list-group-item-head-open]="isCollapsed[index] == false">

          <app-detail-display class="w-mm-30" [value]="owner.PartnershipType | lookup:lang"
            (click)="isCollapsed[index] = !isCollapsed[index]">
          </app-detail-display>

          <app-detail-display *ngIf="isArabic" class="w-mm-50" [value]="owner.NameAr"
            (click)="isCollapsed[index] = !isCollapsed[index]">
          </app-detail-display>

          <app-detail-display *ngIf="!isArabic" class="w-mm-50" [value]="owner.NameEn"
            (click)="isCollapsed[index] = !isCollapsed[index]">
          </app-detail-display>

          <div class="list-group-item-options">
            <ng-container *ngIf="isPowerUser">
              <a class="ds-btn-icon" (click)="edit($event,owner)">
                <i class="fi-register fi-large mx-2"></i>
              </a>
              <a class="ds-btn-icon" (click)="delete(owner)">
                <i class="fi-close-thick mx-2"></i>
              </a>
            </ng-container>
            <a class="ds-btn-icon ds-btn-bg-bright" [attr.aria-expanded]="!isCollapsed[index]"
              (click)="isCollapsed[index] = !isCollapsed[index]">
               <i class="fi-arrow-thin-down"></i>
            </a>
          </div>
        </div>

        <div class="list-group-item-details collapse show w-100" [ngbCollapse]="isCollapsed[index] ?? (isCollapsed[index] = true)">
          <div  class="row px-2">
            <app-detail-display *ngIf="!isArabic" class="col-md-6" key="UserProfile.NameAr" [value]="owner.NameAr">
            </app-detail-display>
  
            <app-detail-display *ngIf="isArabic" class="col-md-6" key="UserProfile.NameEn"  [value]="owner.NameEn">
            </app-detail-display>
  
            <app-detail-display class="col-md-6" key="UserProfile.Nationality"  [value]="owner.Nationality | lookup:lang">
            </app-detail-display>

            <app-detail-display *ngIf="owner.Passport" class="col-md-6" key="UserProfile.Passport"  [value]="owner.Passport">
            </app-detail-display>

            <app-detail-display *ngIf="owner.IdNumber" class="col-md-6" key="UserProfile.IdNumber"  [value]="owner.IdNumber">
            </app-detail-display>
  
            <app-detail-display class="col-md-6" key="UserProfile.Mobile"  [value]="owner.Mobile">
            </app-detail-display>
          </div>
        </div>
      </li>

      <li class="list-group-item d-flex justify-content-start align-items-center px-2">
        <div class="w-mm-50 pt-1"
              *ngIf="activeOwners.length > itemsPerPage">
          <p>
            {{ ("ItemsCount" | translate) +": "+ (activeOwners| searchFilter: searchText).length }} 
          </p>
        </div>
        <div class="w-mm-50 pagination_in">
          <div class="pagination">
            <pagination-controls 
              id="ownersPagination"
              previousLabel="{{'PaginationPreviousLabel' | translate}}"
              nextLabel="{{'PaginationNextLabel' | translate }}"
              (pageChange)="currentPage = $event"
              [autoHide]="true"
              [responsive]="true"
              [maxSize]="3">
            </pagination-controls>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div *ngIf="isRequired">
  <app-list-validation
    name="ownersList"
    [formGroup]="mainForm"
    [items]="activeOwners"
    [min]="1"
    [isEditable]="true"
    minValidationMsgKey="UserProfile.EmptyOwnersMessage.minMessage"> 
  </app-list-validation>
</div>
<div *ngIf="!isRequired">
  <app-list-no-items 
    *ngIf="activeOwners?.length == 0" 
    key="UserProfile.EmptyOwnersMessage">
  </app-list-no-items>
</div>
